<template>
    <div>
        <span class="fs-16">Escolha o tipo de usuário para o filtro</span>
        <b-row  class="mt-2">
            <b-col  cols="12">
                <b-form-group>
                    <b-form-radio-group
                        v-model="selected"
                        :options="options"
                        buttons
                        button-variant="outline-primary"
                        @change="$emit('searchType', selected)"
                    ></b-form-radio-group>
                </b-form-group>
            </b-col>

            <b-col cols="">
                <b-button
                    variant="warning"
                    @click="clean()"
                >
                    Limpar  filtro
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
    name:'FilterTypeClient',
    emits:['searchType'],
    
    data() {
        return  {
            selected: '',
            options: [
                { text: 'Cliente', value: 1},
                { text: 'Profissional', value: 2},
                { text: 'Empresa', value: 3},
                { text: 'Todos', value: ''},
            ]
        }
    },
    methods: {
        clean(){
            this.selected =  ''
            this.$emit('searchType', this.selected);
        }
    }
}
</script>